import { useEffect } from "react";

/** Adds `se-scroll-open` to <html> while mounted (see truthDare.css). */
export default function useUnlockPageScroll() {
  useEffect(() => {
    const html = document.documentElement;
    html.classList.add("se-scroll-open");
    return () => html.classList.remove("se-scroll-open");
  }, []);
}
